module.exports = __webpack_public_path__ + "static/media/Search.99f79f17.svg";